module.exports = __webpack_public_path__ + "4b01cb4664dcbe98a0a92b5d7d6e0e49.png";